<template>
    <div class="card-form restore_password__form mx-auto">
        <div class="restore_password__header">
            <h2 class="restore_password__title">{{$t('lang.pages.forgotpassword.restore_title')}}</h2>
        </div>
        <span class="restore_password__content field">
            <AdaptersPassword
                :class="[v$.currentPass.$error ?  'p-invalid' : '']"
                v-model="currentPass"
                inputId="register__reg_pass"
                :inputProps="{name: 'password'}"
                :placeholder="$t('lang.pages.forgotpassword.new_password_placeholder')"
                required
                toggleMask
                :feedback="false"
            />
            <span
                v-if="v$.currentPass.$error && v$.currentPass.$errors[0].$message > 0"
                class="restore__text-error"
            >
                {{ v$.currentPass.$errors[0].$message }}
            </span>
        </span>
        <Button
            type="submit"
            class="restore_password__btn"
            :class="[disableBtn ? 'restore__btn-disabled' : '']"
            :disabled="disableBtn"
            :label="$t('lang.pages.forgotpassword.new_button_label')"
            @click="restorePassword"
        />
        <AdaptersMessage v-if="error" class="restore_password__message" :message="error" />
        <AdaptersMessage
            v-if="info"
            class="restore_password__message"
            :message="info"
            severity="success"
            icon="pi pi-info-circle"
        />
    </div>
</template>

<script>
import TemplatesPage from "../../templates/Page.vue";
import InputText from "primevue/inputtext";
import Button from "primevue/button";
import { minLength, required, helpers } from "@vuelidate/validators";
import { useVuelidate } from "@vuelidate/core";
import AdaptersMessage from "../../component/adapters/Message.vue";
import UserApi from "../../api/UserApi";
import AdaptersPassword from "../../component/adapters/Password.vue";

export default {
    data() {
        return {
            currentPass: '',
            disableBtn: true,
            code: '',
            error: '',
            info: '',
            v$: null, // для Vuelidate
        };
    },
    created() {
        const rules = {
            currentPass: {
                required: helpers.withMessage('', required),
                minLength: helpers.withMessage(this.$t('lang.registration.password_error_length'), minLength(8)),
            }
        };

        this.v$ = useVuelidate(rules, this);
        this.code = window.location.pathname.split('/')[3];
    },
    methods: {
        restorePassword() {
            this.error = '';
            this.v$.$validate();
            this.disableBtn = this.v$.$errors.length > 0;

            if (!this.disableBtn) {
                this.disableBtn = true;
                UserApi
                    .restorePassword({
                        password: this.currentPass,
                        code: this.code
                    })
                    .then(() => {
                        this.info = this.$t('lang.pages.forgotpassword.restore_info_success');
                    })
                    .catch((error) => {
                        this.disableBtn = false;
                        this.error = error.message;
                    });
            }
        },
    },
    watch: {
        currentPass() {
            this.v$.currentPass.$validate();
            this.disableBtn = this.v$.$errors.length > 0;
        }
    },
    components: {
        AdaptersPassword,
        AdaptersMessage,
        TemplatesPage,
        InputText,
        Button,
    },
};
</script>

<style scoped>
:deep(.p-message.p-message-success .p-message-icon) {
    display: unset;
    color: #9CD651;
}

.p-message.p-message-success {
    background: #ecf8dd;
    border: solid #9CD651;
    border-width: 0 0 0 6px;
    color: #475569;
}

.p-button {
    font-size: 0.875rem!important;
}

</style>
